import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Routes inside the authenticated app where preserving scroll position
// (e.g. returning to a long patients list) is genuinely useful.
const SCROLL_PRESERVE_PREFIXES = ['/dashboard'];

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // For cross-page anchor links (e.g. /products/bio-ply#proof), scroll the
    // target section into view once it has rendered, rather than jumping to top.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let cancelled = false;
      const scrollToTarget = () => {
        if (cancelled) return;
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
      };
      // Retry across ~1s: late-loading images above a deep anchor shift the
      // layout, so a single early scroll can land short of the target.
      scrollToTarget();
      const timers = [80, 250, 500, 900].map((delay) =>
        setTimeout(scrollToTarget, delay)
      );
      return () => {
        cancelled = true;
        timers.forEach(clearTimeout);
      };
    }

    const shouldPreserve = SCROLL_PRESERVE_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    );
    if (shouldPreserve) return;

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
